const tenantsActions = ["editTenant", "toggleTenantStatus", "deleteTenant", "addTenant"] as const;

export default tenantsActions;
